import { bsc, bscTestnet } from 'wagmi/chains';

import ERC20ABI from './ABI/ERC20.json';
import stakingABI from './ABI/staking.json';
import stakingOldABI from './ABI/stakingOld.json';
import lpStakingABI from './ABI/lpStaking.json';
import faucetABI from './ABI/faucet.json';

const TESTMODE = false;

export const ADDRESSES = {
  [bsc.id]: {
    biofi: "0x11A31b833d43853f8869C9EEc17F60e3B4d2a753",
    biofiLP: "0x58a50fc3bc271ccd5a078fab8222b2e021b9f4df",
    stakingOld: "0x43a0FDF139431C0A17942b5A2580FD55d368A558", //needs to be redeployed for this ui update to be applied in prod
    staking: "0x9Cb1526334a0a50DE21e6bf26a9db28f42b52C6B", //needs to be redeployed for this ui update to be applied in prod
    lpStaking: "0xe6aA98070D097080ee6744572EeDdAeb5d68ADcc", //needs to be redeployed for this ui update to be applied in prod
    faucet: "0x192C62326AdA841864F5CE061a11fd3912A9Be47",
  },
  [bscTestnet.id]: {
    biofi: "0x9FA420818AdbD692c243B898E597bb63e6f0b268",
    biofiLP: "0x841e0Dc19A178a959E63de1587D1f5581BA473ea",
    stakingOld: "0x1dF4397F350897893ba3A9BB75ddC341dA20c067",
    staking: "0x1dF4397F350897893ba3A9BB75ddC341dA20c067",
    lpStaking: "0xD06b3b3abFBD83444B63838311e199AaB073E0D5",
    faucet: "0x192C62326AdA841864F5CE061a11fd3912A9Be47",
  }
};

export const ABIS = {
  biofi: ERC20ABI,
  biofiLP: ERC20ABI,
  stakingOld: stakingOldABI,
  staking: stakingABI,
  lpStaking: lpStakingABI,
  faucet: faucetABI,
};

export const NETWORK = TESTMODE ? bscTestnet : bsc;

export const APIURL = TESTMODE ? "https://apitest.biofitoken.io" : "https://api.biofitoken.io";